// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","313":"component---src-pages-contact-tsx","453":"component---src-pages-404-tsx","970":"component---src-pages-about-tsx"}[chunkId] + "-" + {"245":"1925e32390b09cbb49c5","313":"0c8063dc81b186c21c81","453":"6013a5b4caf5960802dc","970":"a1721af9a45ba28a777e"}[chunkId] + ".js";
};